"use client";

// The camera-session hook (getUserMedia lifecycle, permissions handling,
// error classification) is single-sourced in @repeatmd/camera-core/react and
// shared with Admin's in-office consult. Kept as a local re-export so existing
// `@/features/camera/useCameraSession` imports (hook + types) and their test
// mocks keep working. See docs/FRONTEND_TURBOREPO.md.
export {
  useCameraSession,
  type StartCameraOptions,
  type CameraErrorKind,
  type CameraFacingMode,
} from "@repeatmd/camera-core/react";
